module.exports = __webpack_public_path__ + "static/img/87.b67e143.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/87.png
// module id = Dk06
// module chunks = 1